import { Form, FormikProvider, useFormik } from "formik";
import Constants from "../../../../Constants";
import { XInput } from '../../../../components';
import XSelect from '../../../../components/common/XSelect';
import useAxios from "../../../../hooks/useAxios";
import { errorToast, successToast } from "../../../../utils/toast";
import { INTEGRATION_PARTNER_MAP } from "../../../../utils/enum";
import { SINGLE_API_KEY_PARTNERS, INTEGRATION_PARTNER } from "@demandproai/shared";
import * as Yup from 'yup';
import XModal from '../../../../components/common/XModal';

const formWrapperClasses = "grid grid-cols-1 gap-y-4 pt-4";
const formGroupClasses = "relative text-content";

const ExternalApiKeyModal = ({ setShowModal, getApiKeys }) => {
    const { postData } = useAxios();
    const onSubmit = async (values) => {
        const postRes = await postData(Constants.ApiUrl.user.addPartnerApiKey, values);
        if (!postRes.success) {
            errorToast(postRes?.message || "There is some error Please try again");
            return;
        }
        successToast("Partner is Successfully Integrated");
        getApiKeys();
        setShowModal(false);
    }

    const validationSchema = Yup.object({
        partnerId: Yup.string(),
        apiKey: Yup.string(),
        secretApiKey: Yup.string().when('partnerId', {
            is: (partnerId) => partnerId !== INTEGRATION_PARTNER.SMARTADVOCATE,
            then: (schema) =>
                schema
                    .required('Required')
                    .min(5, 'Must be at least 5 characters'),
            otherwise: (schema) => schema.notRequired()
        }),
        username: Yup.string().when('partnerId', {
            is: INTEGRATION_PARTNER.SMARTADVOCATE,
            then: (schema) => schema.required('User name is required'),
            otherwise: (schema) => schema.notRequired()
        }),
        password: Yup.string().when('partnerId', {
            is: INTEGRATION_PARTNER.SMARTADVOCATE,
            then: (schema) => schema.required('Password is required'),
            otherwise: (schema) => schema.notRequired()
        }),
    });
    const getExternalAPIKeyPartnerRegistrationOptions = () => {
        const resultOptions = Object.values(INTEGRATION_PARTNER_MAP).filter(p => {
            return !(SINGLE_API_KEY_PARTNERS.includes(p.value));
        }).map(p => ({
            id: p.key,
            text: p.text,
            value: p.value,
        }));
        return resultOptions;
    }

    const formik = useFormik({
        initialValues: { apiKey: "", partnerId: "", clientId: "", secretApiKey: "", username: "", password: "" },
        enableReinitialize: true,
        validationSchema,
        onSubmit,
    });

    return (
        <XModal
            isOpen={true}
            title="Generate Key"
            onClose={() => setShowModal(false)}
            onSubmit={formik.handleSubmit}
            submitText="Save"
            size="lg"
        >
            <FormikProvider value={formik}>
                <Form>
                    <div className={formWrapperClasses}>
                        <div className={formGroupClasses}>
                            <XSelect
                                name="partnerId"
                                label="Select Partner"
                                emptyOption="None"
                                options={getExternalAPIKeyPartnerRegistrationOptions()}
                                value={formik.values.partnerId}
                                onChange={(e) => {
                                    const newPartnerId = e.target.value;

                                    formik.setFieldValue('partnerId', newPartnerId);
                                    formik.setFieldValue('secretApiKey', '');
                                    formik.setFieldValue('username', '');
                                    formik.setFieldValue('password', '');
                                }}
                            />
                        </div>

                        {formik.values.partnerId === INTEGRATION_PARTNER.SMARTADVOCATE && (
                            <>
                                <div className={formGroupClasses}>
                                    <XInput
                                        name="username"
                                        placeholder=""
                                        label="User Name"
                                        {...formik.getFieldProps("username")}
                                        error={formik.touched.username && formik.errors.username}
                                    />
                                </div>

                                <div className={formGroupClasses}>
                                    <XInput
                                        name="password"
                                        placeholder=""
                                        label="Password"
                                        {...formik.getFieldProps("password")}
                                        error={formik.touched.password && formik.errors.password}
                                    />
                                </div>
                            </>
                        )}

                        {formik.values.partnerId !== INTEGRATION_PARTNER.SMARTADVOCATE && (
                            <>
                                <div className={formGroupClasses}>
                                    <XInput
                                        name="apiKey"
                                        placeholder=""
                                        label="Api Key"
                                        {...formik.getFieldProps("apiKey")}
                                    />
                                </div>

                                <div className={formGroupClasses}>
                                    <XInput
                                        name="secretApiKey"
                                        placeholder=""
                                        label="Secret Api Key"
                                        {...formik.getFieldProps("secretApiKey")}
                                        error={
                                            formik.touched.secretApiKey &&
                                            formik.errors.secretApiKey
                                        }
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </Form>
            </FormikProvider>
        </XModal>
    );
};

export default ExternalApiKeyModal